
import axios from "axios";
import { paramsConfig } from "../../utils/paramsUtils";
import { ISendPeopleTraining } from "../models/sendPeopleTrainingModels";
import { localStorageItem } from "../../utils/localStorage";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
const API_URL = (localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_API_URL) + "/cu-dao-tao";

export const getListSendPeopleTraining = (searchData: any) => {
  let url = `${API_URL}/page`;
  return axios.get(url, paramsConfig(searchData));
};

export const addSendPeopleTraining = (data: ISendPeopleTraining) => {
  let url = `${API_URL}`;
  return axios.post(url, data);
};

export const getSendPeopleTrainingById = (id: string) => {
  let url = `${API_URL}/${id}`;
  return axios.get(url);
};

export const updateSendPeopleTraining = (id: string, data: ISendPeopleTraining) => {
  let url = `${API_URL}/${id}`;
  return axios.put(url, data);
};

export const deleteSendPeopleTraining = (ids: string[]) => {
  let url = `${API_URL}/ids?ids=${ids.toString()}`;
  return axios.delete(url);
};

export const searchBaoCaoCaNhan = (searchObj: any) => {
  return axios.get(`${API_URL}/data-ca-nhan`, paramsConfig(searchObj));
};
